import AccountBoxIcon from '@mui/icons-material/AccountBox'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'
import AppsIcon from '@mui/icons-material/Apps'
import ContactEmergencyIcon from '@mui/icons-material/ContactEmergency'
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode'
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus'
import ExploreIcon from '@mui/icons-material/Explore'
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter'
import GroupIcon from '@mui/icons-material/Group'
import HomeIcon from '@mui/icons-material/Home'
import MapIcon from '@mui/icons-material/Map'
import PersonIcon from '@mui/icons-material/Person'

import { VIEW_TYPES } from '../utils/utility'

export const navigationMap = [
  {
    title: 'Admin Dashboard',
    roles: ['ADMIN', 'INSTRUCTOR'],
    items: [
      { path: '/dashboard', roles: ['ADMIN'], label: 'Admin Dashboard', icon: <AdminPanelSettingsIcon /> },
      { path: '/users', roles: ['ADMIN'], label: 'Users', icon: <GroupIcon /> },
      { path: '/private-session/create', roles: ['INSTRUCTOR'], label: 'Create Private Session', icon: <PersonIcon /> },
      { path: '/group-session/create', roles: ['INSTRUCTOR'], label: 'Create Group Session', icon: <GroupIcon /> },
      { path: '/mysessions', roles: ['INSTRUCTOR'], label: 'Sessions Management', icon: <FitnessCenterIcon />, view: VIEW_TYPES.INSTRUCTOR },
    ],
  },
  {
    title: 'Main',
    items: [
      { path: '/', label: 'Home', icon: <HomeIcon /> },
      { path: '/events', label: 'Upcoming Events', icon: <ExploreIcon /> },
      { path: '/events/trips', label: 'Group Trips', icon: <DirectionsBusIcon /> },
      { path: '/mysessions', label: 'My Sessions', icon: <FitnessCenterIcon />, view: VIEW_TYPES.USER },
    ],
  },
  {
    title: 'Book a Session',
    items: [
      { path: '/events/sessions', label: 'Book Group Session', icon: <FitnessCenterIcon /> },
      { path: '/booking', label: 'Book Private Session', icon: <PersonIcon />, view: VIEW_TYPES.USER },
      { path: '/instructors', label: 'Instructors', icon: <GroupIcon /> },
    ],
  },
  {
    title: 'Development',
    roles: ['ADMIN', 'DEVELOPER'],
    items: [
      { path: '/dev/', roles: ['ADMIN', 'DEVELOPER'], label: 'Developer Main Page', icon: <DeveloperModeIcon /> },
      { path: '/dev/demo', roles: ['ADMIN', 'DEVELOPER'], label: 'Demo Page', icon: <DeveloperModeIcon /> },
      { path: '/dev/comp', roles: ['ADMIN', 'DEVELOPER'], label: 'Component Demo', icon: <AppsIcon /> },
      { path: '/dev/user-card', roles: ['ADMIN', 'DEVELOPER'], label: 'User Card Demo', icon: <AccountBoxIcon /> },
      { path: '/dev/contact-card', roles: ['ADMIN', 'DEVELOPER'], label: 'Contact Card Demo', icon: <ContactEmergencyIcon /> },
    ],
  },
  {
    title: 'Help',
    items: [
      { path: '/sitemap', label: 'Site Map', icon: <MapIcon /> },
      { path: '/feature-dev-map', label: 'Feature Development Map', icon: <MapIcon /> },
    ],
  },
]
